<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout wrap align-center justify-center>
      <v-card class="mx-auto" max-width="500" outlined>
        <v-card-title>{{ $t('auth.recoveryPassword') }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              Introduce tu dirección de correo electrónico para enviarte un correo de recuperación de contraseña.
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-form v-model="isValid">
                <v-text-field
                  v-model="form.email"
                  :rules="rules.email"
                  :label="$t('auth.labels.email')"
                  required />
                <div class="d-flex justify-end">
                  <v-btn
                    depressed
                    rounded
                    color="primary"
                    @click="recovery">
                    {{ $t('auth.labels.sendMail') }}
                  </v-btn>
                </div>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              ¿Quieres iniciar sesión?
              <v-btn
                small
                text
                color="primary"
                to="/login">
                {{ $t('auth.login') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {

  name: 'RecoveryPassword',

  data () {
    return {
      isValid: false,
      form: {
        email: null
      },
      rules: {
        email: [
          v => !!v || this.$t('validations.email.required'),
          v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || this.$t('validations.email.valid')
        ]
      }
    }
  },

  methods: {
    async recovery () {
      if (this.$route.query.provider) {
        this.$store.commit('setUserprovider')
      }
      try {
        await this.$api.post('/v1/recovery-password', {
          email: this.form.email
        })
        this.$toasted.success('Check your email inbox to start the recovery', { duration: 3000 })
      } catch (e) {
        this.$toasted.error(e.message, { duration: 3000 })
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
